export default __webpack_public_path__ + "static/media/log-out.c5d2b1ac.svg";